import React from "react";
import { Moon, Sun } from "lucide-react";

import { useTheme } from "@/contexts/ThemeContext";

/**
 * Chiaro o scuro, in un bottone solo.
 *
 * Due stati e non tre: «automatico» è una terza possibilità che va spiegata, e
 * qui la domanda è una sola - adesso, con questa luce, si legge meglio bianco o
 * nero? La scelta resta in questo browser, e il bianco è il punto di partenza:
 * un testo accademico si scrive e si rilegge su carta bianca.
 */
export default function ThemeToggle({ className = "" }) {
  const tema = useTheme();
  if (!tema) return null;
  const scuro = tema.mode === "dark";
  return (
    <button
      type="button"
      data-testid="theme-toggle"
      aria-pressed={scuro}
      onClick={() => tema.setMode(scuro ? "light" : "dark")}
      title={scuro ? "Passa allo schermo chiaro" : "Passa allo schermo scuro"}
      className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-ink-subtle transition-colors hover:bg-surface-2 hover:text-ink ${className}`}
    >
      {scuro ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      <span className="sr-only">{scuro ? "Schermo chiaro" : "Schermo scuro"}</span>
    </button>
  );
}
